module.exports = "<mat-card-title>Link de confirmación</mat-card-title>\n<mat-card-content>\n  {{ link }}\n</mat-card-content>\n<div class=\"centrarBotones\">\n  <button style=\"margin-right: 10px;\" type=\"button\" mat-raised-button color=\"accent\"\n    (click)=\"copiarLink(); dialogRef.close()\">Copiar al portapapeles</button>\n  <button type=\"button\" mat-raised-button color=\"warn\"\n    (click)=\"dialogRef.close()\">Cancelar</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/modals/link-confirmacion/modal-link-confirmacion.component.html
// module id = ./src/app/shared-components/modals/link-confirmacion/modal-link-confirmacion.component.html
// module chunks = main